import React from 'react';
import PropTypes from 'prop-types';

import PriceBookTableContainer from './PriceBookTableContainer';

export default class PricingIndex extends React.Component {
  static propTypes = {
    accountId: PropTypes.number.isRequired,
    accountSettings: PropTypes.object.isRequired,
    dialog: PropTypes.object.isRequired,
    isSuperAdmin: PropTypes.bool.isRequired,
    priceBook: PropTypes.object.isRequired,
    updatePriceAction: PropTypes.func.isRequired,
    getPriceBookAction: PropTypes.func.isRequired,
    openDialogFunction: PropTypes.func.isRequired,
    closeDialogFunction: PropTypes.func.isRequired,
  };

  toggleDialog = id => {
    const { dialog, openDialogFunction, closeDialogFunction } = this.props;
    if (dialog.show) {
      closeDialogFunction(id);
    } else {
      openDialogFunction(id);
    }
  };

  cancelDialog = id => {
    const { closeDialogFunction } = this.props;
    closeDialogFunction(id);
  };

  render() {
    const {
      accountId,
      accountSettings,
      dialog,
      isSuperAdmin,
      priceBook,
      getPriceBookAction,
      updatePriceAction,
    } = this.props;

    const pricingDisabled = accountSettings.get('PRICING_ENABLED') === false;

    return pricingDisabled ? (
      <div className="main-content">
        <h1>Sorry, pricing is disabled for this account.</h1>
      </div>
    ) : (
      <div className="modal-wrap">
        <div className="container-fluid container-home">
          <div className="header">
            <div className="header-body">
              <div className="row">
                <div className="col-sm-12">
                  <h1 className="header-title">Pricing</h1>
                </div>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-sm-12">
              <PriceBookTableContainer
                accountId={accountId}
                dialog={dialog}
                isSuperAdmin={isSuperAdmin}
                isCRM
                tableContents={priceBook.get('crmList')}
                revShare={priceBook.get('revShare')}
                updatePriceAction={updatePriceAction}
                getPriceBookAction={getPriceBookAction}
                openDialogFunction={this.toggleDialog}
                closeDialogFunction={this.toggleDialog}
              />
            </div>
          </div>
          <div className="row">
            <div className="col-sm-12">
              <PriceBookTableContainer
                accountId={accountId}
                dialog={dialog}
                isSuperAdmin={isSuperAdmin}
                isCRM={false}
                tableContents={priceBook.get('maList')}
                revShare={priceBook.get('revShare')}
                updatePriceAction={updatePriceAction}
                getPriceBookAction={getPriceBookAction}
                openDialogFunction={this.toggleDialog}
                closeDialogFunction={this.toggleDialog}
              />
            </div>
          </div>
        </div>
      </div>
    );
  }
}
